import React from "react";

const AboutSection = () => {
  return (
    <section id="about" className="about-bg" data-testid="about-section">
      <div className="container-hc py-20 md:py-28">
        <div className="max-w-4xl">
          <div className="text-xs font-bold tracking-[0.25em] text-[color:var(--hc-coral)]">
            ABOUT HILLCREST
          </div>

          <h2 className="font-serif-display mt-5 text-4xl sm:text-5xl lg:text-[64px] leading-[1.05] text-[color:var(--hc-navy)]">
            A welcoming community in the heart of San Augustine.
          </h2>

          <p className="mt-8 text-lg md:text-xl text-[color:var(--hc-navy)]/80 leading-relaxed">
            Hillcrest Assisted Living is a welcoming community dedicated to providing
            compassionate care, comfort, and independence for adults who need a little extra
            support in their daily lives. Located at{" "}
            <span className="font-semibold text-[color:var(--hc-navy)]">1997 Davidson Drive</span>,
            our home-like environment offers personalized care, meaningful activities, and a
            strong sense of community for every resident we serve.
          </p>

          <blockquote className="mt-8 border-l-[3px] border-[color:var(--hc-coral)] pl-5 italic font-serif-display text-xl text-[color:var(--hc-navy)]/85 leading-relaxed">
            "Where our home is your home."
          </blockquote>

          <div className="mt-12 grid grid-cols-3 gap-6 md:gap-10 max-w-2xl">
            {[
              { num: "100%", label: "FAMILY-FOCUSED CARE" },
              { num: "24/7", label: "ON-SITE STAFF" },
              { num: "All", label: "FAITHS WELCOME" },
            ].map((s) => (
              <div key={s.label} data-testid={`stat-${s.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}>
                <div className="font-serif-display text-4xl md:text-5xl text-[color:var(--hc-coral)] leading-none">
                  {s.num}
                </div>
                <div className="mt-2 text-[11px] md:text-xs font-bold tracking-[0.18em] text-[color:var(--hc-navy)]/65">
                  {s.label}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
